import { TranslatableKey } from '../translatable.type';

const BenefitInvoiceStatusDisplayOptions: { [key: string]: TranslatableKey } = {
    unsynced: 'benefits.benefitsPayroll.invoiceStatus.unsynced',
    syncing: 'benefits.benefitsPayroll.invoiceStatus.syncing',
    synced: 'benefits.benefitsPayroll.invoiceStatus.synced',
    failed: 'benefits.benefitsPayroll.invoiceStatus.failed',
};

export { BenefitInvoiceStatusDisplayOptions };
